<mat-dialog-content>
  <div class="container simple">
    <h1>Als Reporter bewerben</h1>
    <p>Vielen Dank für dein Interesse, bei {{ teamName }} Reporter zu werden!</p>
    <p>Fülle einfach unten die Felder aus, damit wir uns mit dir persönlich in Verbindung setzen können.</p>
    <h2>Dein Kontakt</h2>
    <form [formGroup]="form" (submit)="onRegister()">
      <mat-form-field hideRequiredMarker class="large" color="primary">
        <mat-label>E-Mail</mat-label>
        <input
          required
          matInput
          type="email"
          name="email"
          formControlName="email"
          autocomplete="email"
          placeholder="E-Mail" />
      </mat-form-field>
      <mat-form-field hideRequiredMarker class="large" color="primary">
        <mat-label>Telefonnummer (optional)</mat-label>
        <input
          matInput
          type="tel"
          name="phone"
          formControlName="phone"
          autocomplete="tel"
          placeholder="+43 664 123 45 67" />
      </mat-form-field>
      <mat-form-field hideRequiredMarker class="large" color="primary">
        <mat-label>Text (optional)</mat-label>
        <input
          matInput
          type="text"
          name="text"
          formControlName="text"
          autocomplete="off"
          placeholder="Text (optional)" />
      </mat-form-field>
    </form>
    <p>Wir werden dich in den nächsten Tagen über einen dieser Wege kontaktieren.</p>
    <p>Liebe Grüße, <br />{{teamName}}</p>
    <button (click)="onRegister()" [disabled]="sendButtonDisabled">Bewerbung absenden</button>
    <p class="error-label" [class.visible]="showErrorLabel">Etwas ist schief gelaufen. Bitte versuche es später erneut.</p>
    <p class="error-label" [class.visible]="showAlreadyRegisteredLabel">Du hast dich bei diesem Team bereits als Teamreporter beworben!</p>
    <p class="success-label" [class.visible]="showSuccessLabel">Danke für deine Anmeldung! Wir werden uns bei dir melden!</p>
  </div>
</mat-dialog-content>
